
import { defineComponent, SetupContext, computed } from "vue";

export default defineComponent({
  name: "ApplianceItem",
  props: {
    /**
     * id
     */
    id: {
      type: Number
    },
    /**
     * 画像
     */
    imageUrl: {
      type: String
    },
    /**
     * ニックネーム
     */
    nickName: {
      type: String,
      required: true
    },
    /**
     * ProductCode
     */
    productCode: {
      type: String,
      required: true
    },
    /**
     * チェック状態
     */
    checked: {
      type: Boolean,
      required: true
    }
  },
  setup(props, context: SetupContext) {
    const checkedImage = () => {
      if (!props.checked) {
        return require("@/assets/images/icn-check-off.png");
      }
      return require("@/assets/images/icn-check-on.png");
    };

    const checkAction = () => {
      context.emit("select-check", props.id, !props.checked);
    };

    const onError = (event: Event) =>{
      if (event.target) {
        (event.target as HTMLImageElement).src = require("@/assets/images/noimage1.png");
      }
    };

    return {
      checkedImage,
      checkAction,
      onError
    };
  }
});
